document.addEventListener("DOMContentLoaded", function () {

  /* =====================================================
     MOBILE MENU
  ===================================================== */

  const menuButton = document.querySelector("[data-velune-menu-toggle]");
  const mobileMenu = document.querySelector("[data-velune-menu]");

  if (menuButton && mobileMenu) {
    menuButton.addEventListener("click", function () {
      mobileMenu.classList.toggle("is-open");
    });
  }


  /* =====================================================
     PRODUCT PAGE
  ===================================================== */

  const slidesContainer = document.querySelector("[data-velune-slides]");
  const slides = Array.from(
    document.querySelectorAll(".velune-product-slide")
  );

  const thumbnails = Array.from(
    document.querySelectorAll(".velune-product-thumbnail")
  );

  const prevButton = document.querySelector("[data-carousel-prev]");
  const nextButton = document.querySelector("[data-carousel-next]");
  const counter = document.querySelector("[data-carousel-counter]");

  const variantDataElement = document.querySelector(
    "[data-product-variants]"
  );

  const variantInput = document.querySelector(
    "[data-selected-variant]"
  );

  const addButton = document.querySelector(
    "[data-add-to-cart]"
  );

  const priceElement = document.querySelector(
    "[data-product-price]"
  );

  const optionButtons = Array.from(
    document.querySelectorAll(".velune-option-button")
  );

  let variants = [];

  if (variantDataElement) {
    try {
      variants = JSON.parse(variantDataElement.textContent);
    } catch (error) {
      variants = [];
    }
  }


  /* =====================================================
     CAROUSEL
  ===================================================== */

  function getCurrentIndex() {

    if (!slidesContainer || !slides.length) {
      return 0;
    }

    const slideWidth = slidesContainer.clientWidth;

    if (!slideWidth) {
      return 0;
    }

    return Math.round(
      slidesContainer.scrollLeft / slideWidth
    );
  }

  function updateCarouselUI(index) {

    if (counter) {
      counter.textContent =
        `${index + 1} / ${slides.length}`;
    }

    thumbnails.forEach(function (thumbnail) {
      thumbnail.classList.toggle(
        "is-active",
        Number(thumbnail.dataset.thumbIndex) === index
      );
    });
  }

  function goToSlide(index) {

    if (!slidesContainer || !slides.length) {
      return;
    }

    index = Math.max(
      0,
      Math.min(index, slides.length - 1)
    );

    slidesContainer.scrollTo({
      left: index * slidesContainer.clientWidth,
      behavior: "smooth"
    });

    updateCarouselUI(index);
  }

  if (slidesContainer) {

    slidesContainer.addEventListener(
      "scroll",
      function () {

        window.requestAnimationFrame(function () {
          updateCarouselUI(getCurrentIndex());
        });

      },
      { passive: true }
    );

  }

  if (prevButton) {
    prevButton.addEventListener("click", function () {
      goToSlide(getCurrentIndex() - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", function () {
      goToSlide(getCurrentIndex() + 1);
    });
  }

  thumbnails.forEach(function (thumbnail) {

    thumbnail.addEventListener("click", function () {

      goToSlide(
        Number(thumbnail.dataset.thumbIndex)
      );

    });

  });

  updateCarouselUI(0);


  /* =====================================================
     PRODUCT VARIANTS
  ===================================================== */

  function getSelectedOptions() {

    const selected = [];

    document
      .querySelectorAll(".velune-product-option")
      .forEach(function (group) {

        const button = group.querySelector(
          ".velune-option-button.is-selected"
        );

        if (button) {
          selected[
            Number(button.dataset.optionPosition)
          ] = button.dataset.optionValue;
        }

      });

    return selected;
  }


  function findVariant() {

    const selectedOptions = getSelectedOptions();

    if (!selectedOptions.length || !variants.length) {
      return null;
    }

    return variants.find(function (variant) {

      if (!variant.options) {
        return false;
      }

      return variant.options.every(function (
        optionValue,
        index
      ) {

        return optionValue === selectedOptions[index];

      });

    }) || null;

  }


  function updateProductState() {

    const variant = findVariant();

    if (!variant) {
      return;
    }

    if (variantInput) {
      variantInput.value = variant.id;
    }

    if (priceElement && variant.price !== undefined) {

      const formattedPrice =
        new Intl.NumberFormat(
          document.documentElement.lang || "fr-FR",
          {
            style: "currency",
            currency: "EUR"
          }
        ).format(variant.price / 100);

      priceElement.textContent =
        formattedPrice;

    }

    if (addButton) {

      addButton.disabled = !variant.available;

      addButton.textContent =
        variant.available
          ? "Ajouter au panier"
          : "Épuisé";

    }

    if (
      variant.featured_media &&
      variant.featured_media.id
    ) {

      const mediaIndex = slides.findIndex(
        function (slide) {

          return Number(
            slide.dataset.mediaId
          ) === Number(
            variant.featured_media.id
          );

        }
      );

      if (mediaIndex >= 0) {
        goToSlide(mediaIndex);
      }

    }

  }


  optionButtons.forEach(function (button) {

    button.addEventListener("click", function () {

      const optionPosition =
        Number(button.dataset.optionPosition);

      document
        .querySelectorAll(
          `.velune-option-button[data-option-position="${optionPosition}"]`
        )
        .forEach(function (item) {
          item.classList.remove("is-selected");
        });

      button.classList.add("is-selected");

      updateProductState();

    });

  });


  /* =====================================================
     QUANTITY
  ===================================================== */

  const quantityInput =
    document.querySelector(
      ".velune-quantity input"
    );

  const quantityMinus =
    document.querySelector(
      "[data-quantity-minus]"
    );

  const quantityPlus =
    document.querySelector(
      "[data-quantity-plus]"
    );

  if (quantityInput) {

    if (quantityMinus) {

      quantityMinus.addEventListener(
        "click",
        function () {

          const current =
            parseInt(quantityInput.value || "1", 10);

          quantityInput.value =
            Math.max(1, current - 1);

        }
      );

    }

    if (quantityPlus) {

      quantityPlus.addEventListener(
        "click",
        function () {

          const current =
            parseInt(quantityInput.value || "1", 10);

          quantityInput.value =
            current + 1;

        }
      );

    }

  }

});